import { getCities } from 'shared/models/city';

const CITIES_LOADING = 'CITY_LIST_LOADING';
const CITIES_LOADED = 'CITY_LIST_LOADED';

const init = {
  list: [],
  loading: false,
  requestedAt: null
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case CITIES_LOADING:
      return { ...state, loading: true };
    case CITIES_LOADED:
      return {
        ...state,
        loading: false,
        list: action.cities,
        requestedAt: action.requestedAt
      };
    default:
      return state;
  }
}

export function loadCities() {
  return dispatch => {
    dispatch({ type: CITIES_LOADING });
    return getCities().then(cities =>
      dispatch({ type: CITIES_LOADED, cities, requestedAt: +new Date() })
    );
  };
}
